var _path, _path2, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCards(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 38,
    viewBox: "0 0 69 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.5272 26.7H46.4763C48.1331 26.7 49.4763 25.3568 49.4763 23.7V11.1689L66.0737 14.0954C67.7054 14.3831 68.7948 15.9391 68.5071 17.5708L65.3815 35.2973C65.0938 36.929 63.5378 38.0185 61.9061 37.7308L44.1796 34.6052C42.5479 34.3174 41.4584 32.7615 41.7461 31.1298L42.5272 26.7Z",
    fill: "#505050"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.2511 0C23.5943 0 22.2511 1.34315 22.2511 3V5.52189L23.681 5.26977C25.3126 4.98206 26.8686 6.07157 27.1563 7.70325L30.0299 24H43.2511C44.908 24 46.2511 22.6569 46.2511 21V3C46.2511 1.34315 44.908 0 43.2511 0H25.2511Z",
    fill: "#505050"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 12.9164,
    width: 24,
    height: 24,
    rx: 3,
    transform: "rotate(-10 0 12.9164)",
    fill: "#505050"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCards);
export default __webpack_public_path__ + "static/media/cards.087d10e2870617091d299407e6fd7af0.svg";
export { ForwardRef as ReactComponent };